import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

import {  fetchRepertoire } from '../services/strapi';
const Repertoire = () => {
  const [repertoire, setRepertoire] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    const getRepertoire = async () => {
      try {
        setLoading(true);
        const data = await fetchRepertoire(); 
        console.log("Fetched Repertoire Data:", data); 
        setRepertoire(data); 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getRepertoire();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;


  
  return (
    <div className="repertoire-grid">
        <div className='repertoire-grid__image'>
            <img src={`${baseUrl}${repertoire.image.formats.large.url}`} alt={repertoire.title}/>
        </div>
        <div className='repertoire-grid__content'>
            <h2 className='repertoire-grid__title'>{repertoire.title}</h2>
            <div className='repertoire-grid__text'>
            <ReactMarkdown>{repertoire.content}</ReactMarkdown>
            </div>
            
        </div>
    </div>
  );
};

export default Repertoire;